// firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAVFW8Y2gO4d5-wr5rCZWrMuexWs7sztOA",
  authDomain: "wtf-member.firebaseapp.com",
  databaseURL: "https://wtf-member-default-rtdb.firebaseio.com",
  projectId: "wtf-member",
  storageBucket: "wtf-member.appspot.com",
  messagingSenderId: "638833786141",
  appId: "1:638833786141:web:b1739a1a4b772fc49ef5f4",
  measurementId: "G-N720MKC0PL",
};

const app = initializeApp(firebaseConfig);

let messaging;
if (
  "Notification" in window &&
  "serviceWorker" in navigator &&
  !/iPad|iPhone|iPod/.test(navigator.userAgent)
) {
  messaging = getMessaging(app);
} else {
  console.warn(
    "Browser does not support Firebase Messaging or it's running on an iOS device."
  );
}

export { messaging };

// const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);
// export { messaging };
